import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';

interface StravaConnectProps {
    isLoading: boolean;
    error: string | null;
    onConnect: () => void;
}

const StravaConnect: React.FC<StravaConnectProps> = ({
    isLoading,
    error,
    onConnect
}) => {
    const intl = useIntl();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', mt: 1 }}>
            <Typography variant="body1" sx={{ mb: 4, textAlign: 'center' }}>
                <FormattedMessage id="comparison.connect.description" />
            </Typography>

            <LoadingButton
                onClick={onConnect}
                variant="outlined"
                fullWidth
                loading={isLoading}
                sx={{ my: 1, py: 1.5 }}
                endIcon={
                    <img
                        src="/images/strava.svg"
                        alt="Strava"
                        style={{ height: 20, marginLeft: 8 }}
                    />
                }
            >
                {intl.formatMessage({ id: 'plans.connectStrava' })}
            </LoadingButton>

            {error && (
                <Typography variant="body2" color="error" sx={{ mt: 2, textAlign: 'center' }}>
                    {intl.formatMessage({ id: error })}
                </Typography>
            )}
        </Box>
    );
};

export default StravaConnect;